import { Code } from "lucide-react";

import type { GenericComponent } from "@src/store/slices/experienceBuilder/types";
import { ModificationListItem } from "@src/features/experienceBuilder/modifications/common/ModificationListItem";

export const GenericComponentListItem = ({
  mod,
}: {
  mod: GenericComponent;
}) => {
  const subtitle = mod.description || "Generic component";
  return (
    <ModificationListItem
      mod={mod}
      icon={<Code size={16} />}
      title="Generic component"
      subtitle={subtitle}
    />
  );
};
